import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { subscriberId: Number, subscriberType: String }
  
  connect() {
    // Modal will be shown when controller connects
    this.showModal()
  }
  
  showModal() {
    const basePath = this.subscriberTypeValue === 'domestic' 
      ? '/admin/subscriber_lists/domestic_subscribers' 
      : '/admin/subscriber_lists/roamers'
    
    const modalHtml = `
      <div class="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
        <div class="relative top-20 mx-auto p-5 border max-w-md shadow-lg rounded-md bg-white">
          <div class="p-6">
            <div class="flex items-center justify-between mb-4">
              <h3 class="text-lg font-medium text-gray-900">Move IMEI to Another List</h3>
              <button type="button" data-action="click->move-list-modal#close" class="text-gray-400 hover:text-gray-600">
                <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
              </button>
            </div>
            
            <p class="text-sm text-gray-600 mb-4">Select a new list for this IMEI. This action will transfer the IMEI from its current list to the selected one.</p>
            
            <form method="post" action="${basePath}/${this.subscriberIdValue}/move" data-turbo="false">
              <input type="hidden" name="authenticity_token" value="${this.csrfToken}">
              
              <div class="space-y-3">
                <div class="flex items-center">
                  <input type="radio" id="list_type_white" name="list_type" value="white" class="h-4 w-4 text-primary focus:ring-primary border-gray-300">
                  <label for="list_type_white" class="ml-2 block text-sm text-gray-700">
                    <span class="font-medium">White List</span>
                    <span class="text-xs text-gray-500 block">Approved devices allowed on the network</span>
                  </label>
                </div>

                <div class="flex items-center">
                  <input type="radio" id="list_type_black" name="list_type" value="black" class="h-4 w-4 text-primary focus:ring-primary border-gray-300">
                  <label for="list_type_black" class="ml-2 block text-sm text-gray-700">
                    <span class="font-medium">Black List</span>
                    <span class="text-xs text-gray-500 block">Blocked devices not allowed on the network</span>
                  </label>
                </div>

                <div class="flex items-center">
                  <input type="radio" id="list_type_gray" name="list_type" value="gray" class="h-4 w-4 text-primary focus:ring-primary border-gray-300">
                  <label for="list_type_gray" class="ml-2 block text-sm text-gray-700">
                    <span class="font-medium">Gray List</span>
                    <span class="text-xs text-gray-500 block">Devices under observation or review</span>
                  </label>
                </div>
              </div>

              <div class="mt-6 bg-yellow-50 border border-yellow-200 rounded-md p-4">
                <div class="flex">
                  <svg class="h-5 w-5 text-yellow-400" fill="currentColor" viewBox="0 0 20 20">
                    <path fill-rule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clip-rule="evenodd"></path>
                  </svg>
                  <div class="ml-3">
                    <h3 class="text-sm font-medium text-yellow-800">Important</h3>
                    <p class="mt-1 text-sm text-yellow-700">
                      Moving this IMEI to another list will affect its network classification. 
                      This action will be logged for audit purposes.
                    </p>
                  </div>
                </div>
              </div>
              
              <div class="flex items-center justify-end space-x-3 mt-6">
                <button type="button" data-action="click->move-list-modal#close" class="px-4 py-2 text-sm text-gray-600 hover:text-gray-800 transition-colors">
                  Cancel
                </button>
                <button type="submit" class="flex items-center justify-center font-semibold text-white bg-primary border border rounded-[8px] px-4 py-2">
                  Confirm
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    `
    
    this.element.innerHTML = modalHtml
  }
  
  close() {
    this.element.remove()
  }
  
  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content || ''
  }
}